import { render, staticRenderFns } from "./OptimizerInfo.vue?vue&type=template&id=f4c8aa42&"
import script from "./OptimizerInfo.vue?vue&type=script&lang=js&"
export * from "./OptimizerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports